import "./InputSearch.scss";
import CategoryTag from "core/tags/category-tag/CategoryTag";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { SEARCH_TYPE } from "constants/constants";
import { useState, useRef, useEffect } from "react";
import InputSearchPopup from "./InputSearchPopup";

const InputSearch = ({
  getOptions,
  getSelectedOptions,
  isEmpty,
  label,
  limitChoice,
  minLength,
  options,
  placeholder,
  popup,
  readOnly,
  required,
  searchType,
  value,
  errors,
  defaultValue = false,
  dataTestId,
}) => {
  const intl = useIntl();
  const [searchOpened, setSearchOpened] = useState(false);
  const [input, setInput] = useState({
    value: value || [],
    error: false,
  });

  const [inputValue, setInputValue] = useState();
  const inputRef = useRef(null);

  const validateInput = (data) =>
    (isEmpty && required) || (data?.length === 0 && required);

  useEffect(() => {
    setInput((old) => ({ ...old, value }));
  }, [value]);

  const close = () => {
    setSearchOpened(false);
  };

  useEffect(() => {
    if (minLength && inputValue?.length >= minLength) {
      getOptions(inputValue);
    }
  }, [inputValue]);

  useEffect(() => {
    if (!searchOpened && limitChoice > 1) {
      setInputValue("");
    }
  }, [searchOpened]);

  useEffect(() => {
    if (!label && !value) {
      setInput({
        value: "",
        error: false,
      });
    }
  }, [value]);

  useEffect(() => {
    setInputValue(
      defaultValue
        ? options?.filter((elm) => elm.value === defaultValue)[0]?.label || ""
        : value[0]?.label
    );
  }, [defaultValue]);

  return (
    <>
      {searchOpened && (
        <div className="input-search-close" onClick={() => close()} />
      )}
      <div className="input-search" ref={inputRef}>
        <div
          className="overlap-group"
          style={{ flexDirection: label ? "column" : "unset" }}
        >
          {label && (
            <label
              className={`label sourcesanspro-normal-shadow-blue-14px ${
                errors?.ref ? "label-error" : "label-standard"
              }`}
            >
              <FormattedMessage {...label} />
              {required && "*"}
            </label>
          )}
          {input?.value?.length > 0 && searchType === SEARCH_TYPE.TAG ? (
            <div
              className="display-inputs-flex input-placeholder sourcesanspro-normal-gray-suit-18px"
              style={{
                pointerEvents: "none!important",
              }}
            >
              {input?.value?.map((e) => {
                return (
                  <CategoryTag
                    key={e.value}
                    type={e.type}
                    label={e.label}
                    showing={true}
                    many={input?.value?.length > 1}
                    deleteOption={!readOnly}
                    onDelete={() => {
                      if (!readOnly) {
                        getSelectedOptions({
                          value: input?.value?.filter(
                            (elm) => elm.value !== e.value
                          ),
                        });
                        setInput({
                          error: validateInput(
                            input?.value?.filter((elm) => elm.value !== e.value)
                          ),
                          value: input?.value?.filter(
                            (elm) => elm.value !== e.value
                          ),
                        });
                      }
                    }}
                  />
                );
              })}
              {!readOnly && (
                <input
                  type="text"
                  className="input-placeholder sourcesanspro-normal-gray-suit-18px"
                  onChange={(e) => {
                    setSearchOpened(true);
                    setInputValue(e.target.value);
                  }}
                  disabled={limitChoice === 1 || readOnly}
                  style={{ width: "50px" }}
                  data-testid={dataTestId}
                />
              )}
            </div>
          ) : (
            <input
              type="text"
              className="input-placeholder sourcesanspro-normal-gray-suit-18px"
              value={inputValue}
              placeholder={placeholder && intl.formatMessage(placeholder)}
              onChange={(e) => {
                setInput({ error: false, value: [] });
                if (minLength) {
                  if (e.target.value.length >= minLength) {
                    setSearchOpened(true);
                  } else setSearchOpened(false);
                } else {
                  setSearchOpened(true);
                }
                setInputValue(e.target.value);
              }}
              disabled={readOnly}
              data-testid={dataTestId}
            />
          )}
        </div>
        {searchOpened ? (
          <InputSearchPopup
            defaultOptions={options}
            title={popup.title}
            inputValue={inputValue}
            setInputValue={setInputValue}
            limit={limitChoice}
            selectedOptions={input.value}
            getSelectedOptions={(sel) => {
              getSelectedOptions({ value: sel });
              setInput({ error: false, value: sel });
              setInputValue(sel[0].label || "");
            }}
            readOnly={readOnly}
            searchType={searchType}
            hide={() => setSearchOpened(!searchOpened)}
          />
        ) : null}
      </div>
    </>
  );
};

InputSearch.propTypes = {
  getSelectedOptions: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool,
  label: PropTypes.object,
  limitChoice: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  popup: PropTypes.object,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  searchType: PropTypes.string,
  value: PropTypes.array,
  minLength: PropTypes.number,
  getOptions: PropTypes.func,
};

InputSearch.defaultProps = {
  isEmpty: false,
  label: null,
  placeholder: null,
  popup: null,
  readOnly: false,
  required: false,
  searchType: SEARCH_TYPE.TAG,
  value: [],
  minLength: null,
  getOptions: null,
};

export default InputSearch;
